const headers = {
  access_token: localStorage.getItem('access_token'),
};

export default headers;



// WEBPACK FOOTER //
// ./src/constants/headers.js